export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';

export const REPORT_TYPES = {
  police: '경찰 사칭',
  prosecutor: '검찰 사칭',
  bank: '금융기관 사칭',
  government: '정부기관 사칭',
  other: '기타',
};

export const REPORT_STATUS = {
  pending: '대기 중',
  approved: '승인됨',
  rejected: '거부됨',
};

export const VICTIM_TYPES = {
  voice_phishing: '보이스피싱',
  smishing: '스미싱',
  pharming: '파밍',
  other: '기타',
};

export const RISK_LEVELS = {
  HIGH: '높음',
  MEDIUM: '중간',
  LOW: '낮음',
  SAFE: '안전',
};

export const BLACKLIST_RISK_LEVELS = {
  low: '낮음',
  medium: '중간',
  high: '높음',
  critical: '치명적',
};

export const FILE_TYPES = {
  video: '비디오',
  audio: '오디오',
};

export const PAGINATION_LIMITS = [10, 20, 50, 100];

export const DEFAULT_PAGE_SIZE = 20;
